import { Chip, ChipProps } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React from "react";

import linearGradient from "@/themes/functions/linearGradient";

type Props = Omit<ChipProps, "color"> & {
  color?: "primary" | "secondary" | "info" | "success" | "warning" | "error" | "light" | "dark";
  bgColor?: "primary" | "secondary" | "info" | "success" | "warning" | "error" | "light" | "dark";
};

const StyledChip: React.FC<Props> = ({ color = "white", bgColor = "dark", sx, ...props }) => {
  const theme = useTheme();
  const { gradients } = theme.palette;

  const gradientColor = gradients[bgColor];
  const chipBackground = linearGradient(gradientColor?.main, gradientColor?.state);

  return (
    <Chip
      {...props}
      sx={{
        background: chipBackground,
        color: `${color}!important`,
        margin: "0 3px 3px 0",
        ...sx,
      }}
    />
  );
};

export default StyledChip;
